import "./App.css";
import { createContext } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "pages/Home";
import Editor from "pages/Editor";
import Create from "pages/Create";
import useProjects from "lib/projects";

export const ProjectsContext = createContext();

function App() {
  const { projects, add, busy } = useProjects();
  return (
    <ProjectsContext.Provider value={{ projects, add, busy }}>
      <Router>
        <Switch>
          <Route path="/" exact>
            <Home />
          </Route>
          <Route path="/create">
            <Create />
          </Route>
          <Route path="/editor/:id?">
            <Editor />
          </Route>
        </Switch>
      </Router>
    </ProjectsContext.Provider>
  );
}

export default App;
